import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function SubscriptionCanceledPage() {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: 440, margin: '48px auto 0' }}>
      <div className="pk-card" style={{ textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <div className="pk-i-plate" style={{ width: 56, height: 56, borderRadius: '50%' }}>
            <XCircle size={26} />
          </div>
        </div>

        <h1 className="pk-h2" style={{ marginBottom: 10 }}>Checkout Canceled</h1>

        <p className="pk-body" style={{ marginBottom: 20 }}>
          You've canceled the checkout process. No charges have been made.
        </p>

        <div className="pk-note pk-note-accent" style={{ marginBottom: 20, textAlign: 'left' }}>
          <p className="pk-small">If you experienced any issues or have questions, please contact our support team.</p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button type="button" onClick={() => navigate('/plans')} className="pk-btn pk-btn-ink pk-btn-block">
            View Plans Again
          </button>

          <button type="button" onClick={() => navigate('/plans')} className="pk-btn pk-btn-outline pk-btn-block">
            View Plans & Billing
          </button>
        </div>
      </div>
    </div>
  );
}
